/* eslint-disable prefer-destructuring */
export function getRefFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('ref') || urlParams.get('from');
}

export function saveRef(ref) {
  if (ref) {
    sessionStorage.setItem('refSource', ref);
    document.cookie = `refSource=${ref};path=/;max-age=86400`;
  }
}

export function loadRef() {
  // 先看 sessionStorage
  let ref = sessionStorage.getItem('refSource');
  if (ref) return ref;

  // 再看 cookie
  const match = document.cookie.split('; ').find((row) => row.startsWith('refSource='));
  if (match) {
    ref = match.split('=')[1];
    sessionStorage.setItem('refSource', ref); // 補寫回 sessionStorage
    return ref;
  }

  return 'unknown';
}

/**
 * 放在每頁 mounted 時自動呼叫
 */
export function persistRefFromURL() {
  const ref = getRefFromURL();
  if (ref) {
    saveRef(ref);
    return ref;
  }
  return loadRef();
}
